export default class FormValidatorUploader {
    cvfUploadedDivs;

    constructor() {
        this.cvfUploadedDivs = document.querySelectorAll('div[classFormGroup="cvf_uploaded"]');

        if (this.cvfUploadedDivs.length > 0) {
            this.cvfUploadedDivs.forEach((div) => {
                this.observer = new MutationObserver(this.handleMutation.bind(this));
                this.observer.observe(div, {
                    childList: true,
                    attributes: true,
                    subtree: true
                });
            });
        }
    }


    handleMutation(mutationList) {

        let z = 0;
        for (let mutation of mutationList) {
            if (mutation.type === 'attributes') {

                if (mutation.target) {

                    const result = this.fileValidation(mutation.target);

                    const imagesCount = result.imagesCount;
                    const errors = result.errors.join(' ');

                    const myTarget = mutation.target.parentElement.querySelector('.dz-sum-error')


                    if (myTarget && mutation.target.type !== 'hidden') {
                        z++;
                        myTarget.innerHTML = "";

                        if (result.errors.length > 0) {
                            myTarget.innerHTML = errors;
                        } else {
                            if (mutation.target.querySelectorAll('.dz-preview').length === 0) {
                                myTarget.innerHTML = "Dołącz wymagane dokumenty";


                            } else {

                                myTarget.innerHTML = '';
                                // console.log("imagesCount" + "====" + imagesCount);
                            }
                        }
                    }
                }
            }
        }
    }

    fileValidation(target) {

        let sum = 0;
        let mb;
        let itemLimit=10;
        let imagesCount = 0;
        let maxFileSize = 30;

        if (target.querySelectorAll('.dz-preview').length > 0) {
            let images = target.querySelectorAll('.dz-preview');

            let imagespreview = target.querySelectorAll('.dz-preview');
            let options = target.querySelector('.dynamic-multi-file');
            const uniqueValues = new Set();

            if (options && options.hasAttribute('data-engine-options')) {

                const optionsAtribute = JSON.parse(options.getAttribute('data-engine-options'));

                itemLimit = optionsAtribute.item_limit;
                maxFileSize = optionsAtribute.max_file_size;


            }
            imagesCount = images.length + imagespreview.length;
            const imagesSize = target.querySelectorAll('.dz-size');
            const errorMesssages = target.querySelectorAll('.dz-error-message');

            if (imagesSize.length > itemLimit) {
                uniqueValues.add("Za duża ilość załączników. ");
               // console.log(imagesCount+"   >   "+itemLimit)
            }


            imagesSize.forEach(nodeDz => {
                if (nodeDz.innerHTML.includes('MB')) {
                    mb = 1024;
                } else if (nodeDz.innerHTML.includes('GB')) {
                    mb = 1024*1024;
                }else {
                    mb = 1;
                }
                const strongElement = nodeDz.querySelector('strong');

                if (strongElement) {
                    const textContent = strongElement.textContent.trim();
                    const numericValue = parseFloat(textContent);
                    sum = sum + numericValue * mb / 1024;
                }
            });

            const errorMessagesMap = {
                "form_builder.dynamic_multi_file.too_many_items": "Za duża ilość załączników. ",
                "form_builder.dynamic_multi_file.file_is_too_large": "Zbyt duży plik. ",
                "form_builder.dynamic_multi_file.file_invalid_extension": "Niewłaściwy format pliku. ",
            };

            errorMesssages.forEach(nodeDz => {
                const textContent = nodeDz.textContent.trim();
                const translatedMessage = errorMessagesMap[textContent];
                nodeDz.textContent = translatedMessage;
                if (translatedMessage) {
                    uniqueValues.add(translatedMessage);
                }

                if (imagesCount/2 > itemLimit) {
                    uniqueValues.add("Za duża ilość załączników. ");
                    // console.log(imagesCount+" > "+itemLimit)
                }
                if (imagesCount === 0) {
                    uniqueValues.add("Dodaj wymagane załączniki. ");
                }
                if (sum > maxFileSize) {
                    uniqueValues.add("Zbyt duża łączna pojemność ładowanych plików . ");
                }
            });

            const uniqueValuesArray = Array.from(uniqueValues);
            return {
                imagesCount: imagesCount,
                sum: sum,
                message: `Suma wszystkich (${imagesCount}.length) znalezionych wartości: ` + sum + ' MB',
                errors: uniqueValuesArray
            }

        } else {
            return {
                imagesCount: 0,
                sum: 0,
                message: `Suma wszystkich (${imagesCount}.length) znalezionych wartości: ` + sum + ' MB',
                errors: ["Brak wynaganych załączników. "]
            };
        }

    }
}